export default {"src":"/_next/static/media/recipe.aab03a9a.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};